import { render, staticRenderFns } from "./privacy_h5.vue?vue&type=template&id=be846efc&scoped=true"
import script from "./privacy_h5.vue?vue&type=script&lang=js"
export * from "./privacy_h5.vue?vue&type=script&lang=js"
import style0 from "./privacy_h5.vue?vue&type=style&index=0&id=be846efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be846efc",
  null
  
)

export default component.exports